<template>
  <div class="box">
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="head_box">
        <div class="li">
          <div class="top">{{ i18n.issuingdate }}</div>
          <div class="bot">{{ top_data.issue_time }}</div>
        </div>
        <div class="li">
          <div class="top">{{ i18n.Consensusalgorithm }}</div>
          <div class="bot">{{ top_data.pot }}</div>
        </div>
        <div class="li">
          <div class="top">{{ i18n.HighestTPS }}</div>
          <div class="bot" style="color: #006aff">{{ top_data.high_tps }}</div>
        </div>
        <div class="li">
          <div class="top">TPS</div>
          <div class="bot" style="color: #006aff">{{ top_data.tps }}</div>
        </div>
      </div>
    </div>
    <div class="mid_box">
      <div class="middle">
        <div class="top">
          <div class="li">{{ i18n.actionmessage }}</div>
          <div class="li">{{ i18n.AddressOverview }}</div>
          <div class="li">{{ i18n.NodeOverview }}</div>
        </div>
        <div class="bottom">
          <div class="list">
            <div class="li">
              <div class="bot_top">{{ i18n.Totalnumberofblocks }}</div>
              <div class="bot">{{ info.block_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Totalnumberofactivities }}</div>
              <div class="bot">{{ info.all_active_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Numberofregularactivities }}</div>
              <div class="bot">{{ info.ordinary_active_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Numberofcontractactivities }}</div>
              <div class="bot">{{ info.contract_active_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.NumberofContentActivities }}</div>
              <div class="bot">{{ info.content_active_nums }}</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="list">
            <div class="li">
              <div class="bot_top">{{ i18n.Totalnumberofaddresses }}</div>
              <div class="bot">{{ info.address_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Numberofaccounts }}</div>
              <div class="bot">{{ info.account_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Numberofcontractaddresses }}</div>
              <div class="bot">{{ info.contract_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.NumberofContentAddresses }}</div>
              <div class="bot">{{ info.content_nums }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.Numberofnewlyaddedaccounts }}</div>
              <div class="bot">{{ info.add_account_num }}</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="list">
            <div class="li">
              <div class="bot_top">{{ i18n.Totalnumberofnodes }}</div>
              <div class="bot">{{ node_info.total }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.oneNum }}</div>
              <div class="bot">{{ node_info.level_0 }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.twoNum }}</div>
              <div class="bot">{{ node_info.level_1 }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.threeNum }}</div>
              <div class="bot">{{ node_info.level_2 }}</div>
            </div>
            <div class="li">
              <div class="bot_top">{{ i18n.fourNum }}</div>
              <div class="bot">{{ node_info.level_3 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="activity_box">
      <div class="activity">
        <div class="head">
          # &nbsp;&nbsp;&nbsp;<span>{{ i18n.Recentactivities }}</span>
        </div>
        <div class="list" v-for="(item, index) in last_active" :key="index">
          <div class="li">
            <img src="../../image/homePage/logo.png" alt="" />
            <div class="name">VoidChain</div>
            <div class="desc">(TC)</div>
          </div>
          <div class="li">
            <div class="num" style="color: #006aff; cursor: pointer" @click="identifyInputType(item.number)">{{ item.number }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
          <div class="li">
            <div class="hash" v-for="(i, inx) in item.senders" :key="inx">{{ i.slice(0, 24) + '...' }}</div>
            <div class="time">{{ item.txns_num }}{{ i18n.transaction }}</div>
          </div>
          <div class="li">TX</div>
          <div class="li hash">
            <span style="color: #006aff; cursor: pointer" v-for="i in item.trans_hash" :key="i.type" @click="identifyInputType(i.hash)">{{ i.hash.slice(0, 24) + '...' }}</span>
          </div>
          <div class="li">
            <div v-for="i in item.trans_hash" :key="i.type">
              <span v-if="i.type === 1">{{ i18n.Ordinaryactivities }}</span>
              <span v-if="i.type === 2">{{ i18n.Transferactivity }}</span>
              <span v-if="i.type === 3">{{ i18n.Equipmentactivities }}</span>
              <span v-if="i.type === 4">{{ i18n.Contentactivities }}</span>
              <span v-if="i.type === 5">{{ i18n.Platformactivities }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShardInformation',
  data() {
    return {
      title: '',
      info: {},
      top_data: {},
      node_info: {},
      last_active: [],
    }
  },
  computed: {
    i18n() {
      return this.$t('ShardInformation')
    },
  },
  mounted() {
    this.title = this.$route.query.name
    this.getslicenoDetails()
  },
  methods: {
    getslicenoDetails() {
      this.$axios
        .post('/index/web/slicenoDetails', {
          sliceno: this.$route.query.sliceno,
        })
        .then((res) => {
          this.info = res.data.data
          this.top_data = res.data.data.top_data
          this.node_info = res.data.data.node_info
          this.last_active = res.data.data.last_active
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch meta space details:', error)
          // Set default values to prevent UI issues
          this.info = {}
          this.top_data = {}
          this.node_info = {}
          this.last_active = []
        })
    },
    isHash(value) {
      const sha256Regex = /^0x[a-fA-F0-9]{64}$/ // SHA-256 哈希值
      return sha256Regex.test(value)
    },
    isValidEthereumAddress(address) {
      const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/
      return ethAddressRegex.test(address)
    },
    isBlockNumber(input) {
      const blockNumberRegex = /^\d+$/ // 非负整数
      return blockNumberRegex.test(input)
    },
    identifyInputType(info) {
      if (this.isHash(info)) {
        console.log('hash')
        this.$router.push({ path: '/OnChainQuery', query: { id: 2, content: info, sliceno: this.$route.query.sliceno } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
      } else if (this.isValidEthereumAddress(info)) {
        this.$router.push({ path: '/OnChainQuery', query: { id: 1, content: info, sliceno: this.$route.query.sliceno } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
        console.log('ethereum address')
      } else if (this.isBlockNumber(info)) {
        this.$router.push({ path: '/OnChainQuery', query: { id: 3, content: info, sliceno: this.$route.query.sliceno } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
        console.log('block number')
      } else {
        console.log('unknown') // 若不符合任何类别，则标记为未知
      }
    },
  },
}
</script>
<style lang="scss" src="./ShardInformation.scss" scoped></style>
